import { Flashbar, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { DEFER, TABLE_CONTENT_TYPE } from 'src/commons/constants';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { ReviewReviewer, ReviewReviewerList } from 'aws-sdk/clients/awsdlomni';
import { ReviewAgreement } from 'src/components/reviews/reviewAgreement';
import { groupReviewersByResourceAgreement, updateAgreement } from 'src/components/reviews/utils';
import { ReviewAgreementsResponseList } from 'src/components/reviews/types';
import { ReviewLinks } from 'src/components/reviews/reviewLinks';

export interface ReviewAgreementsProps {
  setContentType: React.Dispatch<React.SetStateAction<string>>;
  match: any;
  reviews: ReviewReviewerList;
  reviewersByAgreement: ReviewAgreementsResponseList;
  setReviewersByAgreement: React.Dispatch<React.SetStateAction<ReviewAgreementsResponseList>>;
  disabled?: boolean;
  filter?: (review: ReviewReviewer) => boolean;
  includeAgreementLinks?: boolean;
}

export const ReviewAgreements = (props: ReviewAgreementsProps) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    console.log('ReviewAgreements remounted', props.reviews);
    props.setContentType(TABLE_CONTENT_TYPE);
  }, []);

  useEffect(() => {
    console.log('ReviewAgreements updated', props.reviews);
    const filteredReviews = props.reviews.filter((review) => review['action'] != DEFER);
    const reviewersByAgreement = groupReviewersByResourceAgreement(filteredReviews);
    if (props.filter && filteredReviews.filter(props.filter).length == 0) {
      setNotifications([
        {
          type: 'success',
          content: 'No questionnaires need to review, you can click Next button to continue',
          dismissible: true,
          onDismiss: () => setNotifications([]),
        },
      ]);
    }
    props.setReviewersByAgreement(reviewersByAgreement);
  }, [props.reviews]);

  return (
    <>
      <Flashbar items={notifications} />
      <SpaceBetween size='m' direction='vertical'>
        {props.reviewersByAgreement.map((agreement, idx) => {
          let reviewsNeedAgreementCheck = agreement.reviewers.filter(props.filter ?? ((_) => true));
          if (reviewsNeedAgreementCheck.length == 0) {
            return;
          } else {
            return (
              <ReviewAgreement
                header={props.includeAgreementLinks ? <ReviewLinks reviewers={reviewsNeedAgreementCheck} /> : undefined}
                agreementData={JSON.parse(agreement.agreement.agreementData)}
                agreementId={agreement.agreement.agreementId}
                reviews={reviewsNeedAgreementCheck}
                disabled={props.disabled}
                d3AValidationOutput={agreement.agreement?.d3AValidationOutput}
                overrideReason={agreement.agreement?.overrideReason}
                setOverrideReason={(override: string) =>
                  updateAgreement(props.setReviewersByAgreement, idx, { overrideReason: override })
                }
                setAgreementData={(newData: object) =>
                  updateAgreement(props.setReviewersByAgreement, idx, { agreementData: JSON.stringify(newData) })
                }
                match={props.match}
                setContentType={props.setContentType}
              />
            );
          }
        })}
      </SpaceBetween>
    </>
  );
};
